import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

import PublicLayout from './layouts/PublicLayout';
import Layout from './layouts/Layout';

import LandingPage from './pages/LandingPage';
import InvitationPage from './pages/InvitationPage';
import LaunchButtonPage from './pages/LaunchButtonPage';
import CountdownCelebrationPage from './pages/CountdownCelebrationPage';
import CountdownCelebrationPageDirect from './pages/CountdownCelebrationPageDirect';
import InstallPage from './pages/InstallPage';
import DownloadPage from './pages/DownloadPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Notifications from './pages/Notifications';
import AdminDashboard from './pages/AdminDashboard';
import UnauthorizedPage from './pages/Unauthorized';
import RoadmapPitchPage from './pages/RoadmapPitchPage';
import InstallCard from './pages/InstallCard';

import PartnerJoinPage from './pages/PartnerJoinPage';

import ProtectedRoute from './components/ProtectedRoute';
import InitialLoader from './components/InitialLoader';

import { NavigationProvider } from './context/NavigationContext';
import { NotificationProvider } from './context/NotificationContext';
import { AuthContext } from './context/AuthContext';

const App = () => {
  const { isInitialLoad } = useContext(AuthContext);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out',
      once: true,
    });
  }, []);

  if (isInitialLoad) return <InitialLoader />;

  return (
    <Router>
      <NavigationProvider>
        <NotificationProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<PublicLayout><LandingPage /></PublicLayout>} />
            <Route path="/invitation" element={<PublicLayout><InvitationPage /></PublicLayout>} />
            <Route path="/launch-button" element={<LaunchButtonPage />} />
            <Route path="/countdown" element={<CountdownCelebrationPage />} />
            <Route path="/countdown-direct" element={<CountdownCelebrationPageDirect />} />
            <Route path="/install" element={<PublicLayout><InstallPage /></PublicLayout>} />
            <Route path="/download" element={<PublicLayout><DownloadPage /></PublicLayout>} />
            <Route path="/install-card" element={<InstallCard />} />
            <Route path="/privacy" element={<PublicLayout><PrivacyPolicyPage /></PublicLayout>} />
            <Route path="/account/delete" element={<PublicLayout><AccountDeletionPage /></PublicLayout>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/roadmap" element={<RoadmapPitchPage />} />
            <Route path="/partner-join" element={<PublicLayout><PartnerJoinPage /></PublicLayout>} /> {/* ✅ Ini route barunya */}

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />

            {/* Authenticated */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="notifications" element={<Notifications />} />
            </Route>

            {/* Fallback */}
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </NotificationProvider>
      </NavigationProvider>
    </Router>
  );
};

export default App;
